<template>
  <div>
    <p class="mt-4 mb-8">
      Medidas de Elementos & Espaçamento se referem a distância entre um objeto
      e outro, não importa a natureza dele. <br />
      Toda medida de distância tem que ser divisível por 8px, e quando não,
      divisível por 2px.
    </p>

    <div class="flex flex-col gap-2">
      <div v-for="(title, space) in spaces" :key="space" class="items-center flex">
        <span class="mr-2 w-12 text-xs">{{ title }}</span>
        <span :class="space" class="bg-pink-600 block"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spaces: {
          'w-1 h-1' : '4px',
          'w-2 h-2' : '8px',
          'w-3 h-3' : '12px',
          'w-4 h-4' : '16px',
          'w-5 h-5' : '20px',
          'w-6 h-6' : '24px',
          'w-10 h-10' : '40px',
          'w-12 h-12' : '48px',
          'w-16 h-16' : '64px',
          'w-18 h-18' : '72px',
          'w-20 h-20' : '80px',
      }
    }
  }
}
</script>